module.exports = __webpack_public_path__ + "img/clutch.6997ab4f.svg";